import { Group } from "@mantine/core"
import { MultiSelect } from "@tfg/ui"
import React, { Dispatch } from "react"

import { FindIngestionSettingsResponseDto } from "~/gen/api"

type Props = {
  update: Dispatch<React.SetStateAction<FindIngestionSettingsResponseDto>>
  defaultStandards: string[]
  standardsOptions: string[]
}
export function DefaultStandards({
  defaultStandards,
  update,
  standardsOptions,
}: Props) {
  function handleChange(value: string[]) {
    update((prev) => ({ ...prev, defaultStandards: value }))
  }

  return (
    <Group justify="flex-end" w="100%">
      <MultiSelect
        data={standardsOptions}
        value={defaultStandards}
        clearable
        searchable
        w="80%"
        onChange={handleChange}
      />
    </Group>
  )
}
